import { AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest } from "@/api/client";
import { handleError } from "@/api/handleError";
import { getAvailableAddress } from "@/api/requests/address";
import {
  cancelRenewalForAddress,
  getAllAddressForBusiness,
} from "@/api/requests/addressAddon";
import { useNumberAddressAddOnStore } from "@/stores/add-ons/number-address.store";
import { notify } from "@kyvg/vue3-notification";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { useBusinessStore, useNumberStore } from "../stores";

const pageSize = 100;

export const useAddress = () => {
  const numberAddressAddOnStore = useNumberAddressAddOnStore();

  const route = useRoute();

  const router = useRouter();

  const numberStore = useNumberStore();

  const { selectedAddress, addresses } = storeToRefs(numberAddressAddOnStore);

  const handleFetchAddress = async (
    payload: AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest = {}
  ) => {
    try {
      const addressResponse = await getAvailableAddress({
        pageSize,
        ...payload,
      });
      return addressResponse;
    } catch (error) {
      handleError({ error });
    }
  };

  const handleFetchBusinessAddresses = async () => {
    const businessStore = useBusinessStore();

    const businessId = businessStore.currentBusinessId;
    try {
      if (!businessId) {
        throw new Error("Business ID is required");
      }
      const addressResponse = await getAllAddressForBusiness({
        businessId,
        pageSize: 50,
      });

      handleAddressViewRedirect();
      return addressResponse?.data?.data;
    } catch (error) {
      handleError({ error });
      return [];
    }
  };

  const handleAddressViewRedirect = () => {
    // check if its an address only user so as to redirect
    // an address only user does not have a business number but only addresses
    if (
      !numberStore.allNumbersRegisteredUnderABusiness?.length &&
      !route.path.includes("address-user") &&
      !route.path.includes("additional-purchase") &&
      !route.path.includes("provision-number") &&
      addresses.value?.length
    ) {
      void router.push("/address-user");
      // redirect to the address only layout
    }
  };

  const handleCancelRenewal = async (id: number) => {
    const businessStore = useBusinessStore();

    const businessId = businessStore.currentBusinessId;

    try {
      if (!businessId) {
        throw new Error("Business ID is required");
      }

      const response = await cancelRenewalForAddress({
        addressId: id,
        businessId,
      });

      notify({
        type: "success",
        text: "Address renewal cancelled",
      });

      return response?.data;
    } catch (error) {
      handleError({ error });
    }
  };

  return {
    handleFetchAddress,
    selectedAddress,
    handleFetchBusinessAddresses,
    handleCancelRenewal,
  };
};
